import '@angular/compiler';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PageAuthoringReview_batchesComponent } from './page.authoring.review_batches/page.authoring.review_batches.component';
import { PageAuthoringReleasesComponent } from './page.authoring.releases/page.authoring.releases.component';
import { PageAuthoringDashboardComponent } from './page.authoring.dashboard/page.authoring.dashboard.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageAuthoringQualityComponent } from './page.authoring.quality/page.authoring.quality.component';
import { PageWorkspaceComponent } from './page.workspace/page.workspace.component';
import { PageAuthoringDatasetsComponent } from './page.authoring.datasets/page.authoring.datasets.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PageAuthoringAdjudicationsComponent } from './page.authoring.adjudications/page.authoring.adjudications.component';
import { PageAuthoringRunsComponent } from './page.authoring.runs/page.authoring.runs.component';
import { LayoutAuthComponent } from './layout.auth/layout.auth.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageAuthoringCandidatesComponent } from './page.authoring.candidates/page.authoring.candidates.component';
import { PageStatusForbiddenComponent } from './page.status.forbidden/page.status.forbidden.component';
import { LayoutReviewComponent } from './layout.review/layout.review.component';
import { PageReviewTasksComponent } from './page.review.tasks/page.review.tasks.component';
import { PageStatusNot_foundComponent } from './page.status.not_found/page.status.not_found.component';
import { LayoutAuthoringComponent } from './layout.authoring/layout.authoring.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PageAdminAccountsComponent } from './page.admin.accounts/page.admin.accounts.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PageStatusPendingComponent } from './page.status.pending/page.status.pending.component';
import { PageAuthoringSourcesComponent } from './page.authoring.sources/page.authoring.sources.component';
import { PageSignupComponent } from './page.signup/page.signup.component';
import { PageAuthoringText_unitsComponent } from './page.authoring.text_units/page.authoring.text_units.component';

const INDEX_PAGE = "access";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutAuthoringComponent,
        "children": [
            {
                "path": "authoring/review-batches",
                component: PageAuthoringReview_batchesComponent,
                "app_id": "page.authoring.review_batches"
            },
            {
                "path": "authoring/releases",
                component: PageAuthoringReleasesComponent,
                "app_id": "page.authoring.releases"
            },
            {
                "path": "authoring",
                component: PageAuthoringDashboardComponent,
                "app_id": "page.authoring.dashboard"
            },
            {
                "path": "authoring/quality",
                component: PageAuthoringQualityComponent,
                "app_id": "page.authoring.quality"
            },
            {
                "path": "authoring/datasets",
                component: PageAuthoringDatasetsComponent,
                "app_id": "page.authoring.datasets"
            },
            {
                "path": "authoring/adjudications",
                component: PageAuthoringAdjudicationsComponent,
                "app_id": "page.authoring.adjudications"
            },
            {
                "path": "authoring/runs",
                component: PageAuthoringRunsComponent,
                "app_id": "page.authoring.runs"
            },
            {
                "path": "authoring/candidates",
                component: PageAuthoringCandidatesComponent,
                "app_id": "page.authoring.candidates"
            },
            {
                "path": "admin/accounts",
                component: PageAdminAccountsComponent,
                "app_id": "page.admin.accounts"
            },
            {
                "path": "authoring/sources",
                component: PageAuthoringSourcesComponent,
                "app_id": "page.authoring.sources"
            },
            {
                "path": "authoring/text-units",
                component: PageAuthoringText_unitsComponent,
                "app_id": "page.authoring.text_units"
            }
        ]
    },
    {
        component: LayoutAuthComponent,
        "children": [
            {
                "path": "workspace",
                component: PageWorkspaceComponent,
                "app_id": "page.workspace"
            },
            {
                "path": "forbidden",
                component: PageStatusForbiddenComponent,
                "app_id": "page.status.forbidden"
            },
            {
                "path": "not-found",
                component: PageStatusNot_foundComponent,
                "app_id": "page.status.not_found"
            },
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            },
            {
                "path": "status/pending",
                component: PageStatusPendingComponent,
                "app_id": "page.status.pending"
            },
            {
                "path": "signup",
                component: PageSignupComponent,
                "app_id": "page.signup"
            }
        ]
    },
    {
        component: LayoutReviewComponent,
        "children": [
            {
                "path": "review",
                component: PageReviewTasksComponent,
                "app_id": "page.review.tasks"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }
